import React, { useEffect, useState } from "react";
import { SingleCardMetric } from "../ui/SingleCardMetric";
interface GoalsCompletedMetricState {
  data: any;
  readOnly?: boolean;
  setSelectedData: (data: any[] | null) => void;
  setDataHeaders: (data: any[] | null) => void;
  active?: boolean;
  onHandleClick?: any;
}

export const GoalsCompletedMetric = ({
  data,
  readOnly = true,
  setSelectedData,
  setDataHeaders,
  active,
  onHandleClick,
}: GoalsCompletedMetricState) => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [completed, setCompleted] = useState<any[]>();

  const tableHeaders = [
    { label: "Case ID", key: "case_id", hide: true },
    { label: "Case", key: "case_name" },
    { label: "Goal ID", key: "id", hide: true },
    { label: "Goal", key: "goal_name" },
    { label: "Name", key: "subject.name" },
    { label: "Completed", key: "completed_at_formatted" },
  ];

  useEffect(() => {
    if (data) {
      const { goals } = data;
      const completed = goals?.filter((g: any) => g.completed_at);
      setCompleted(completed);
    }
    setIsLoading(false);
  }, [data]);

  const onViewDetails = () => {
    if (!active) {
      setSelectedData(completed || null);
    } else {
      setSelectedData(null);
    }

    setDataHeaders(tableHeaders);
    onHandleClick();
  };

  if (readOnly) {
    return <SingleCardMetric title={"Goals Completed"} total={completed?.length} isLoading={isLoading} />;
  } else {
    return (
      <SingleCardMetric
        title={"Goals Completed"}
        total={completed?.length}
        onHandleClick={onViewDetails}
        cursor={true}
        active={active}
        isLoading={isLoading}
      />
    );
  }
};
